export const headTableCells = [
  { id: 1, property: '', label: '', width: '5%' },
  { id: 2, property: 'Title', label: 'Title', width: '30%' },
  { id: 3, property: 'CustomerName', label: 'Customer', width: '20%' },
  { id: 4, property: 'ConsultantName', label: 'Consultant', width: '20%' },
  { id: 5, property: 'StatusTitle', label: 'Status', width: '15%' },
  { id: 6, property: 'CreatedOn', label: 'Date', width: '10%' },
];
